import { memo } from 'react';
import ThumbnailEvent from '@/widgets/strips-management/ui/thumbnail/thumbnailEvent';
import useDeviceEventPreviewStrip from './useDeviceEventPreviewStrip';

export type DeviceEventPreviewStripProps = {
  // keyRecoil/activeButton are read via props but the only caller (deviceStripEvents.tsx)
  // never passes them - pre-existing gap, left as-is.
  keyRecoil?: any;
  activeButton?: any;
  id?: any;
  isSelected?: boolean;
  isActive?: boolean;
  sizeThumbnailConfig: any;
  event: any;
  overlayContent?: any;
  index?: any;
  onClickSelectEvent?: (event: any, index: any) => void;
};

/**
 * One selectable thumbnail in the device event strip grid. useDeviceEventPreviewStrip resolves the click handler and the pending-change element, which flags the thumbnail as changed; selection and active state come straight from props.
 *
 * @param props - Thumbnail props carrying the strip id, the event, its selected and active flags and the thumbnail size config.
 * @returns The rendered event thumbnail with its selected, active and changed styling.
 */
const DeviceEventPreviewStrip = ({
  keyRecoil,
  activeButton,
  id,
  isSelected,
  isActive,
  sizeThumbnailConfig,
  event,
  overlayContent,
  index,
  onClickSelectEvent,
}: DeviceEventPreviewStripProps) => {
  const { eleChange, onClick } = useDeviceEventPreviewStrip({
    keyRecoil,
    activeButton,
    event,
    overlayContent,
    index,
    onClickSelectEvent,
  });

  return (
    <ThumbnailEvent
      id={id}
      onClickSelect={onClick}
      isSelected={isSelected}
      isActive={isActive}
      isChanged={!!eleChange}
      sizeThumbnailConfig={sizeThumbnailConfig}
      event={event}
    />
  );
};

export default memo(DeviceEventPreviewStrip);
